module.exports = __webpack_public_path__ + "static/media/abbvie_logo.10f6cedc.png";